<!-- Product -->
<form autocomplete="off" fxLayout="column" [formGroup]="form">
  <kl-base-product-autocomplete
    formControlName="product">
  </kl-base-product-autocomplete>
</form>
<!-- Product -->
